// /stacks/traffic/dev/frontend/src/features/sightings/ImagesPanel.jsx
import React, { useEffect, useState } from "react";

function prettyCam(c) {
  const s = String(c || "");
  if (s.toLowerCase() === "cheltenham") return "Cheltenham";
  if (s.toLowerCase() === "pool") return "Pool";
  return s; // e.g., "41"
}

export default function ImagesPanel({ context, files }) {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const onEsc = (e) => { if (e.key === "Escape") setLightbox(null); };
    if (lightbox) window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [lightbox]);

  const card  = { background: "#111826", border: "1px solid #1f2834", borderRadius: 10, padding: 16, marginTop: 14 };
  const head  = { display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" };
  const title = { fontSize: 16, color: "#e6edf3", margin: 0 };
  const dot   = <span style={{ opacity: 0.4, padding: "0 6px" }}>•</span>;
  const meta  = { fontSize: 12, opacity: 0.8, display: "flex", alignItems: "center", gap: 0, flexWrap: "wrap" };

  const grid  = { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, alignItems: "stretch" };
  const tile  = { background: "#0f141c", border: "1px solid #1f2834", borderRadius: 10, padding: 8, display: "flex", flexDirection: "column", minHeight: 220 };
  const legend= { fontSize: 12, color: "#9fb4d6", margin: "0 0 8px 0" };
  const img   = { display: "block", width: "100%", height: "100%", objectFit: "contain", borderRadius: 8, background: "#000", cursor: "zoom-in" };

  const open = (src, alt) => { if (src) setLightbox({ src, alt }); };

  const HeaderMeta = () => {
    if (!context?.plate && !context?.camera && !context?.time) {
      return <div style={{ ...meta, opacity: 0.6 }}>Select a row below to load images…</div>;
    }
    const pieces = [];
    if (context?.plate) pieces.push(<>Plate: <strong>{context.plate}</strong></>);
    if (context?.camera) pieces.push(<>{prettyCam(context.camera)}</>);
    if (context?.time) pieces.push(<>{context.time}</>); // already friendly from Sightings.jsx
    return (
      <div style={meta}>
        {pieces.map((p, i) => (
          <React.Fragment key={i}>
            {i > 0 ? dot : null}
            {p}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const Img = ({ label, src }) => (
    <div style={tile}>
      <div style={legend}>{label}</div>
      {src ? (
        <img src={src} alt={label} style={img} onClick={() => open(src, label)} />
      ) : (
        <div
          style={{
            flex: 1,
            border: "1px dashed #2a3a55",
            borderRadius: 8,
            display: "grid",
            placeItems: "center",
            color: "#7d94b8",
            fontSize: 12,
          }}
        >
          No {label.toLowerCase()} image
        </div>
      )}
    </div>
  );

  return (
    <section className="card" style={{ marginTop: 12 }}>
      <div style={head}>
        <h3 style={title}>Images</h3>
        <HeaderMeta />
      </div>

      <div style={grid}>
        <Img label="Vehicle"    src={files?.vehicle} />
        <Img label="Background" src={files?.background} />
        <Img label="Plate"      src={files?.plate} />
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 bg-black/85 z-50 grid place-items-center"
          onClick={() => setLightbox(null)}
          role="dialog"
          aria-modal="true"
        >
          <img
            src={lightbox.src}
            alt={lightbox.alt || "zoom"}
            className="max-w-[96vw] max-h-[96vh] rounded-xl shadow-2xl"
          />
        </div>
      )}
    </section>
  );
}
